import React, { useState } from "react";
import "./style/pdvlandingpage.css";
import welcomeImage from "./assets/pdvimages/image-44@2x3000.webp";
import bg_down_arrow from "./assets/pdvimages/bg_down_arrow.svg";
import spiral_2 from "./assets/pdvimages/spiral_2.svg";
import spiral_3 from "./assets/pdvimages/spiral_3.svg";
import bg_waves from "./assets/pdvimages/bg_waves.svg";
// import left from "./assets/pdvimages/chevron-left.svg";
// import right from "./assets/pdvimages/chevron-right.svg";
// import { Carousel } from "react-bootstrap";
import {
  // carouseldata,
  hospicesIcons,
  pdvIcons,
  volunteerAssociations,
  values,
  choosePdvIcons,
} from "./data/pdvLandingPageData";
import { notification, Space } from "antd";
import SectionHeader from "./SectionHeader";
import FooterComponent from "./footer/FooterComponent";
import HeaderComponent from "./header/HeaderComponent";
import ModalPublicFormRendererComponent from "../generic/forms/ModalPublicFormRendererComponent";
import { executeIntent } from "../utils/IntentExecutor";
import IntentType from "../../intentexecutor/utils/IntentType";
import { useNavigate } from "react-router";
import { Helmet } from "react-helmet-async";
import StickyButton from "../../components/generic/stickybutton/StickyButton";

// const NextIcon = () => (
//   <span className="carousel-control-next-icon" aria-hidden="true">
//     <img src={right} alt="" />
//   </span>
// );
// const PrevIcon = () => (
//   <span className="carousel-control-prev-icon" aria-hidden="true">
//     <img src={left} alt="" />
//   </span>
// );

const PdvLandingPage = () => {
  const [openDemoRequestModal, setOpenDemoRequestModal] = useState(false);
  const [formTemplateData, setFormTemplateData] = useState({});
  const navigate = useNavigate();

  const onDataSubmitCallback = () => {
    setOpenDemoRequestModal(false);
    notification.success({
      message:
        "Thank you for requesting a demo! Our team will get in touch with you shortly.",
      placement: "bottomRight",
    });
  };

  const openScheduleADemo = async () => {
    try {
      const payload = {
        configurationKey: ["niramaya.publicform.scheduleademo"],
      };
      const response = await executeIntent(
        IntentType.GET_PUBLIC_CONFIGURATION,
        payload
      );
      if (response[0].configurationValue) {
        setFormTemplateData(JSON.parse(response[0].configurationValue));
        setOpenDemoRequestModal(true);
      }
    } catch (err) {
      notification.error({
        message: "Error while getting form",
        placement: "bottomRight",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>PDV – HIPAA-Compliant Volunteer Management Software</title>
        <meta name="description" content="Patient Data Vault offers HIPAA-compliant hospice volunteer management with EHR integration, hour tracking, and secure documentation." />
        <meta property="og:title" content="PDV – HIPAA-Compliant Volunteer Management Software" />
        <meta name="keywords" content="Hospice volunteer management software, Proven Experience, Comprehensive Solution, Supportive Community, Across the Nation: 88 Hospice Offices Served, Trusted by Over 8000 Volunteers and Managers , Integrates easily with your existing EHRs, Comprehensive Forms Library, Accurate Volunteer Hour Tracking, Easy Documentation & Compliance, Efficient Communications, Intelligent Assistants, Hospice Volunteer Association, Compassion, Security, Innovation, Collaboration,  HIPAA-compliant ,  offers advanced solutions, Volunteer scheduling tool, Patient Data Vault, PDV" />
        <meta property="abstract" content="Patient Data Vault (PDV) is the first HIPAA-compliant EHR system designed specifically for hospice volunteer programs. Developed in 2008 to address security concerns with electronic patient data sharing, PDV has since evolved into a comprehensive volunteer management solution. It integrates volunteer recruiting, management, communications, activity coordination, reporting, education, and HR tracking while ensuring regulatory compliance. PDV's growth is driven by collaboration with the Hospice Volunteer Association (HVA) and its subscriber community, serving hospices with secure and efficient volunteer program management." />
      </Helmet>
      <StickyButton />
    <section className="pdv-landing-page">
      <HeaderComponent />
      {/* <!-- Welcome Page --> */}
      <section id="welcome" className="">
        <div className="container-fluid">
          <div className="row">
            <div className="welcome-screen-home-layout col-md-6 px-5 d-flex justify-content-center align-items-center">
              <div>
                <div className="discover-pdv">
                  Discover the PDV – Your Comprehensive Volunteer Program
                  Management Solution for End-of-Life Care
                </div>
                <Space className="my-3">
                  <button
                    className="custom-button my-1"
                    onClick={openScheduleADemo}
                  >
                    Schedule a Demo
                  </button>
                  <button
                    className="custom-button my-1"
                    onClick={() => navigate("/login")}
                  >
                    Login
                  </button>
                </Space>
                <div className="my-1">
                  <span className="welcome-page-count">300,000+ </span>
                  <span>
                    PDV reports have been generated and processed by HVA for our
                    member hospices that document the many ways that volunteers
                    have compassionately supported
                  </span>{" "}
                  <span className="welcome-page-count">70,000+ </span>
                  <span>patients and their families. </span>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <img
                src={welcomeImage}
                alt="Hospice volunteer providing comfort"
                className="img-fluid"
                width="80%"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <SectionHeader title="Our Mission" />
        <div className="text-center my-3">
          The Patient Data Vault (PDV) was originally developed in 2008 to
          resolve common security issues associated with sharing sensitive
          patient data electronically over the Internet. Since then, the PDV has
          evolved into a comprehensive HIPAA-compliant volunteer program
          management system for use in Hospice Care.
        </div>
      </section>

      <section className="container mt-5">
        <SectionHeader title="Our Values" />
        <div className="container">
          <div className="row justify-content-center d-flex align-items-stretch">
            {values.map((item, i) => (
              <div className="col-12 col-sm-6 col-md-3 d-flex" key={i}>
                <div className="values-card p-3 text-center mx-auto d-flex flex-column position-relative z-1">
                  <img src={item.icon} className="mx-auto d-block" alt={item.alt} />
                  <p className="mt-3 values-card-title">{item.title}</p>
                  <p className="values-card-desc">{item.decscription}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container mt-3">
        <SectionHeader title="Why Choose PDV?" />
        <div className="container">
          <div className="row justify-content-center d-flex align-items-stretch">
            {choosePdvIcons.map((item, i) => (
              <div className="col-12 col-sm-6 col-md-3 d-flex" key={i}>
                <div className="values-card p-3 text-center mx-auto d-flex flex-column position-relative z-1">
                  <img src={item.icon} className="mx-auto d-block" alt={item.alt} />
                  <p className="mt-3 values-card-title">{item.title}</p>
                  <p className="values-card-desc">{item.decscription}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <!-- Our Partners Page --> */}
      <section className="my-5 position-relative">
        <div className="spiral spiral_2">
          <img src={spiral_2} alt="" />
        </div>
        <div className="bg_waves">
          <img src={bg_waves} alt="" />
        </div>
        <div className="container">
          <SectionHeader
            title="Across the Nation: 88 Hospice Offices Served, Trusted by Over 8000
            Volunteers and Managers"
          />
          <div className="container">
            <div className="row">
              {hospicesIcons.map((icon, i) => (
                <div className="col-6 col-sm-6 col-md-3 my-3" key={i}>
                  <img
                    src={icon}
                    className="mx-auto d-block"
                    alt="logo"
                    width="150px"
                    height="70px"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Features and Benefits Page --> */}
      <section id="features" className="features">
        <div className="container-fluid">
          <SectionHeader title="PDV Meet’s Unique Needs" />
          <div className="container">
            <div className="row justify-content-center d-flex align-items-stretch">
              {pdvIcons.map((item, i) => (
                <div className="col-12 col-sm-6 col-md-3 d-flex" key={i}>
                  <div className="pdvIcon-card rounded p-3 text-center my-3 mx-auto d-flex flex-column">
                    <img
                      src={item.icon}
                      className="mx-auto d-block"
                      alt={item.alt}
                    />
                    <p className="mt-3 pdvIcon-card-title">{item.title}</p>
                    <p className="pdvIcon-card-desc">{item.decscription}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Hospice Volunteer Association */}
      <section className="position-relative">
        <div className="spiral spiral_3">
          <img src={spiral_3} alt="" />
        </div>
        <div className="spiral spiral_4">
          <img src={spiral_2} alt="" />
        </div>
        <div className="bg_down_arrow_2">
          <img src={bg_down_arrow} alt="" className="img-fluid" />
        </div>
        <div className="container">
          <SectionHeader title="Hospice Volunteer Association" />
          <p className="text-center hva-text mb-2">
            The Hospice Volunteer Association (HVA) supports hospice volunteers
            worldwide with strong programs and caring standards for end-of-life
            care. Patient Data Vault (PDV), as an HVA managed service, ensures
            that these standards are upheld through secure and efficient data
            management solutions.
          </p>

          <div className="container">
            <div className="row justify-content-center">
              {volunteerAssociations.map((item, index) => (
                <div className="col-12 col-md-4" key={index}>
                  <div className="d-flex flex-column flex-row align-items-center p-3 my-3 mx-auto volunteer-association-card text-center">
                    <div>
                      <img
                        src={item.img}
                        alt="img"
                        className="img-fluid volunteer-association-card-img"
                      />
                    </div>
                    <div>
                      <p className="volunteer-association-card-title">
                        <a
                          className="volunteer-association-card-btn"
                          href={item.link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {item.title}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Testimonials Page --> */}
      {/* <section id="testimonials" className="py-5">
        <SectionHeader title="What Hospices Say About PDV" />
        <div className="container-fluid">
          <div className="background-footer-image">
            <div className="row">
              <div className="col-lg-8 col-md-8 mx-auto d-flex justify-content-center align-items-center">
                <Carousel
                  nextIcon={<NextIcon />}
                  prevIcon={<PrevIcon />}
                  slide={true}
                >
                  {carouseldata.map((item, index) => (
                    <Carousel.Item key={item.id}>
                      <div className="rounded p-4 mb-5 bg-white position-relative carousel-testimonial">
                        <div className="row justify-content-center"> */}
      {/* <div className="col-auto">
                            <img
                              src={item.image}
                              width="50px"
                              height="50px"
                              alt=""
                            />
                          </div> */}
      {/* </div>
                        <div className="text-center mb-4">
                          <h4>{item.name}</h4>
                          <span>{item.role}</span>
                        </div>
                        <div>
                          <p className="text-center">{item.description}</p>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
          </div> */}
      {/* <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 text-center">
              <button className="custom-button-border">Schedule a Demo</button>
            </div>
          </div> */}
      {/* </div>
      </section> */}

      {/* Footer  */}
      <FooterComponent />

      {openDemoRequestModal && (
        <ModalPublicFormRendererComponent
          formTitle="Schedule a Demo"
          formTemplateData={formTemplateData}
          isModalOpen={openDemoRequestModal}
          footer={null}
          formSubmitCallback={onDataSubmitCallback}
          setIsModalOpen={setOpenDemoRequestModal}
        />
      )}
    </section>
    </>
  );
};

export default PdvLandingPage;
